import { useMapEvents } from 'react-leaflet';
import { toast } from 'sonner';

// Konum seçimi için marker
export function LocationMarker({ setCoordinates, setParkForm, parkForm }) {
  useMapEvents({
    click(e) {
      const { lat, lng } = e.latlng;
      
      // setParkForm varsa onu kullan (ParksTab için)
      if (setParkForm && parkForm) {
        setParkForm({
          ...parkForm,
          latitude: lat,
          longitude: lng
        });
        toast.success(`Park konumu seçildi: ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
      }
      // setCoordinates varsa onu kullan (diğer kullanımlar için)
      else if (setCoordinates) {
        setCoordinates({ lat, lng });
        toast.success(`Konum seçildi: ${lat.toFixed(6)}, ${lng.toFixed(6)}`);
      }
    },
  });
  return null;
}
